<template>
    <div class="next_page">
        <div class="suspension" @click="handelClick('previous')" :style="{cursor: 'pointer',color:isControl?'#333':'#fff'}">
            <svg style="transform: translateY(-1px);" width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M7.4741 6.86191C7.39133 6.94779 7.27784 6.99729 7.15859 6.99954C7.03933 7.00179 6.92406 6.95661 6.8381 6.87391L4.1381 4.32391C4.09455 4.28193 4.05991 4.2316 4.03625 4.17593C4.01259 4.12026 4.00039 4.0604 4.00039 3.99991C4.00039 3.93942 4.01259 3.87955 4.03625 3.82388C4.05991 3.76821 4.09455 3.71788 4.1381 3.67591L6.8381 1.12591C6.88022 1.08286 6.93055 1.0487 6.9861 1.02546C7.04166 1.00222 7.10132 0.990366 7.16155 0.990604C7.22177 0.990842 7.28133 1.00317 7.33671 1.02685C7.39208 1.05053 7.44214 1.08508 7.48391 1.12846C7.52568 1.17184 7.55833 1.22317 7.5799 1.27939C7.60147 1.33562 7.61154 1.39561 7.60951 1.4558C7.60748 1.51599 7.59338 1.57516 7.56806 1.6298C7.54274 1.68444 7.50671 1.73344 7.4621 1.77391L5.0993 3.99991L7.4621 6.22591C7.54798 6.30868 7.59749 6.42217 7.59974 6.54142C7.60199 6.66068 7.5568 6.77595 7.4741 6.86191ZM3.8741 6.86191C3.79133 6.94779 3.67784 6.99729 3.55859 6.99954C3.43933 7.00179 3.32406 6.95661 3.2381 6.87391L0.538102 4.32391C0.49455 4.28193 0.459908 4.2316 0.436247 4.17593C0.412586 4.12026 0.400391 4.0604 0.400391 3.99991C0.400391 3.93942 0.412586 3.87955 0.436247 3.82388C0.459908 3.76821 0.49455 3.71788 0.538102 3.67591L3.2381 1.12591C3.28022 1.08286 3.33055 1.0487 3.38611 1.02546C3.44166 1.00222 3.50132 0.990366 3.56155 0.990604C3.62177 0.990842 3.68133 1.00317 3.73671 1.02685C3.79208 1.05053 3.84214 1.08508 3.88391 1.12846C3.92568 1.17184 3.95833 1.22317 3.9799 1.27939C4.00147 1.33562 4.01154 1.39561 4.00951 1.4558C4.00748 1.51599 3.99338 1.57516 3.96806 1.6298C3.94274 1.68444 3.90671 1.73344 3.8621 1.77391L1.4993 3.99991L3.8621 6.22591C3.94798 6.30868 3.99749 6.42217 3.99974 6.54142C4.00199 6.66068 3.9568 6.77595 3.8741 6.86191Z"
                    :fill="isControl?'#333':'#fff'" />
            </svg>
            <span style="margin-left: 4px;">上一篇: <span >{{ props.previousText }}</span></span>
        </div>
        <div class="suspension" @click="handelClick('next')" :style="{cursor: 'pointer',color:isControl?'#333':'#fff'}">
            <!-- <img src="@/assets/image/next.svg" alt=""> -->
            下一篇: <span style="margin-right: 4px;">{{ props.nextText }} </span>
            <svg style="transform: translateY(-1px);" width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M0.525898 6.86191C0.608673 6.94779 0.722158 6.99729 0.841414 6.99954C0.960671 7.00179 1.07594 6.95661 1.1619 6.87391L3.8619 4.32391C3.90545 4.28193 3.94009 4.2316 3.96375 4.17593C3.98741 4.12026 3.99961 4.0604 3.99961 3.99991C3.99961 3.93942 3.98741 3.87955 3.96375 3.82388C3.94009 3.76821 3.90545 3.71788 3.8619 3.67591L1.1619 1.12591C1.11978 1.08286 1.06945 1.0487 1.0139 1.02546C0.958336 1.00222 0.898677 0.990366 0.838453 0.990604C0.77823 0.990842 0.718667 1.00317 0.663294 1.02685C0.607921 1.05053 0.557864 1.08508 0.51609 1.12846C0.474316 1.17184 0.441675 1.22317 0.4201 1.27939C0.398526 1.33562 0.388457 1.39561 0.390491 1.4558C0.392525 1.51599 0.40662 1.57516 0.43194 1.6298C0.457261 1.68444 0.493291 1.73344 0.537898 1.77391L2.9007 3.99991L0.537898 6.22591C0.452016 6.30868 0.402511 6.42217 0.400261 6.54142C0.398011 6.66068 0.4432 6.77595 0.525898 6.86191ZM4.1259 6.86191C4.20867 6.94779 4.32216 6.99729 4.44141 6.99954C4.56067 7.00179 4.67594 6.95661 4.7619 6.87391L7.4619 4.32391C7.50545 4.28193 7.54009 4.2316 7.56375 4.17593C7.58741 4.12026 7.59961 4.0604 7.59961 3.99991C7.59961 3.93942 7.58741 3.87955 7.56375 3.82388C7.54009 3.76821 7.50545 3.71788 7.4619 3.67591L4.7619 1.12591C4.71978 1.08286 4.66945 1.0487 4.61389 1.02546C4.55834 1.00222 4.49868 0.990366 4.43845 0.990604C4.37823 0.990842 4.31867 1.00317 4.26329 1.02685C4.20792 1.05053 4.15786 1.08508 4.11609 1.12846C4.07432 1.17184 4.04167 1.22317 4.0201 1.27939C3.99853 1.33562 3.98846 1.39561 3.99049 1.4558C3.99252 1.51599 4.00662 1.57516 4.03194 1.6298C4.05726 1.68444 4.09329 1.73344 4.1379 1.77391L6.5007 3.99991L4.1379 6.22591C4.05202 6.30868 4.00251 6.42217 4.00026 6.54142C3.99801 6.66068 4.0432 6.77595 4.1259 6.86191Z"
                    :fill="isControl?'#333':'#fff'" />
            </svg>
        </div>
    </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'
const props = defineProps({
    previousText: {
        type: String,
        default: '暂无'
    },
    nextText: {
        type: String,
        default: '暂无'
    },
    isControl: {
        type: Boolean,
        default: false
    },
})
const emits = defineEmits(['pageEvent'])
const handelClick = (item) => {
    // console.log(item);
    emits('pageEvent', item)
}
</script>

<style lang="scss" scoped>
.next_page {
    color: #fff;
    width: 100%;
    display: flex;
    justify-content: space-between;
    font-size: 12px;
}
.suspension {
    display: flex;
    align-items: center;
}

.suspension:hover {
    color: #386AEA!important;

    svg {
        path {
            fill: #386AEA!important;
        }
    }
}</style>